import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../../global/mediaQueryMixin';

interface FileTypeProps {
  fontSize?: number;
}

const FileBox = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  flex-wrap: wrap;
  gap: var(--space-8);
  cursor: pointer;
  margin-block: var(--space-4);
  ${mobile_xl(css`
    grid-template-columns: auto;
  `)}
`;

const FileDiv = styled.div`
  width: 240px;
  ${mobile_xl(css`
    width: 100%;
  `)}
`;

const FileType = styled.div<FileTypeProps>`
  display: flex;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-46%, -30%);
  color: var(--text-primary);
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
`;

const FileIconDiv = styled.div`
  position: relative;
  .file-text {
    display: flex;
    justify-content: center;
    position: absolute;
    width: 50%;
    font-weight: 700;
    color: var(--text-secondary);
  }
`;

export { FileBox, FileDiv, FileType, FileIconDiv };
